import { render } from "./SupportIcon.vue?vue&type=template&id=6d385fe7&ts=true"
import script from "./SupportIcon.vue?vue&type=script&lang=ts"
export * from "./SupportIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__